"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_1 = __importDefault(require("lodash"));
exports.defaultLocale = {
    formatNumber: function (value) { return value.toString(); },
    formatWithDigits: lodash_1.default.identity,
};
var LocaleContext = react_1.createContext(exports.defaultLocale);
exports.LocaleProvider = LocaleContext.Provider;
exports.default = LocaleContext;
//# sourceMappingURL=locale.context.js.map